import React, { useCallback, useMemo } from "react";
import { Button } from "antd";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { handleBackTop } from "@/components/BackTop";

const useButton = (shopId, tab, totalPages) => {
    const orderManagementStore = useOrderManagementStore();

    const pageNo = orderManagementStore.table.pagination.pageNo;

    const onPrevButtonClick = useCallback(() => {
        if (pageNo > 1) {
            handleBackTop();

            orderManagementStore.table.changePageNo(pageNo - 1);

            orderManagementStore.fetchOrders(shopId, tab);
        }
    }, [pageNo, shopId, tab]);

    const onNextButtonClick = useCallback(() => {
        handleBackTop();

        if (pageNo) {
            orderManagementStore.table.changePageNo(pageNo + 1);
        } else {
            orderManagementStore.table.changePageNo(1);
        }

        orderManagementStore.fetchOrders(shopId, tab);
    }, [pageNo, shopId, tab]);

    const preButton = useMemo(() => {
        return (
            <Button type="text" size="small" disabled={pageNo <= 1} onClick={onPrevButtonClick}>
                上一页
            </Button>
        );
    }, [pageNo, onPrevButtonClick]);

    const nextButton = useMemo(() => {
        return (
            <Button
                type="text"
                size="small"
                className="ml10"
                onClick={onNextButtonClick}
                disabled={pageNo >= totalPages}
            >
                下一页
            </Button>
        );
    }, [onNextButtonClick, pageNo, totalPages]);

    return {
        preButton,
        nextButton,
    };
};

export default useButton;
